import { FPError, SkyscannerResultsV3 } from 'types';
import { RouteLocationRaw } from 'vue-router';

export namespace FlightSearch {


	export enum State {
    Idle = 'idle',
    InProgress = 'inprogress',
    Success = 'success',
    Failed = 'failed',
  }

	export interface LiveResults {
		sessionId: string,
		state: SkyscannerResultsV3.ResultStatus, 
		action: SkyscannerResultsV3.ResultAction,
		itineraries: FlightSearch.Itineraries[],
	}

  export interface IState {
    state: State;
    error?: FPError;
    searchFinishedTime?: number;
  }

  export class SearchState implements IState {

    state: State;
    error?: FPError;
    searchFinishedTime?: number;
    
    constructor(x: IState) {
      this.state = x.state;
      this.error = x.error;
      this.searchFinishedTime = x.searchFinishedTime;
    } 

    static default = (): SearchState => {
      return new SearchState({ state: State.Idle });
    }    

    loading = (): boolean => this.state === State.InProgress;

    isFailed = (): boolean => this.state === State.Failed;

  }

	export interface Itineraries {
		prices: Price[];
		dealsCount: number;
		adults: number;
		inboundLeg?: Leg;
		outboundLeg: Leg;
		duplicate?: string;
	}

	export interface BookingDetailsLink {
		body: string;
		method: string;
		uri: string;
	}

	export interface Agent {
		id: string;
		name: string;
		type: string;
		imageUrl: string;
		carrier?: Carrier;
	}

	export interface Carrier {
		id: string;
		alliance?: Alliance;
		displayCode?: string;
		name: string;
		imageUrl: string;
	}

	export interface Alliance {
		id: string;
		name: string;
	}

	export interface Price {
		id: string;
		items: PriceItems[];
		totalPrice: number;
		isMashUp: boolean;
	}

	export interface PriceItems {
		agent: Agent;
		link: string;
		price: number;
		fares?: SkyscannerResultsV3.Fares[];
	}

	export interface Leg {
		id: string;
		dates: Dates;
		carriers: Carrier[];
		duration: Duration;
		stopsDuration: Duration;
		segments: Segment[],
		stations: Stations,
	}

	export interface Duration {
		duration: number;
		title: string;
	}

	export interface Dates {
		arrivalDate: Date;
		departureDate: Date;
		arrivalDisplay: string;
		departureDisplay: string;
	}

	export interface Place {
		id: string;
		code?: string;
		type: string;
		name: string;
		parent?: Place;
	}
	
	export interface Segment {
		id: string;
		marketingCarrier: Carrier;
		operatingCarrier: Carrier;
		departureDate: Date,
		arrivalDate: Date,
		destinanionStation: Place,
		originStation: Place,
		duration: Duration,
		flightNumber?: string;
	}

	export interface Stations {
		origin: Place,
		destination: Place,
		stops: Place[],
	}

	export interface Destination {
    link: RouteLocationRaw;
    title: string;
    price: string;
		image: string;
		destinationName: string;
		originIATA?: string;
		destinationIATA: string;
		originName?: string;
		departDate: Date;
  }

  export interface Destinations {
    from: SkyscannerResultsV3.PlaceShort;
    destinations: Destination[];
  }

}